import { useMemo } from 'react';
import { EventInstanceStore } from '../../../stores/EventInstanceStore';
import { ScheduleStore } from '../../../stores/ScheduleStore';
import { UserStore } from '../../../stores/UserStore';
import { getScheduleForDate } from '../utils/scheduleUtils';

/**
 * Hook for managing day detail mode in Home component
 */
export const useHomeDayDetailMode = (
  isDayDetail: boolean,
  selectedDate: Date | null | undefined,
  eventInstanceStore: EventInstanceStore,
  scheduleStore: ScheduleStore,
  userStore: UserStore,
  format: (date: Date, formatStr: string) => string
) => {
  const dayDetailData = useMemo(() => {
    if (!isDayDetail || !selectedDate) {
      return null;
    }

    const schedule = getScheduleForDate(
      selectedDate,
      eventInstanceStore,
      scheduleStore,
      userStore,
      format
    );
    const currentSchedule = scheduleStore.getScheduleForDate(selectedDate);

    return {
      schedule,
      currentSchedule,
    };
  }, [
    isDayDetail,
    selectedDate,
    eventInstanceStore.instancesByDate,
    eventInstanceStore.instances,
    scheduleStore.templates,
    userStore.userId,
    userStore.users,
    format,
  ]);

  return dayDetailData;
};
